<ng-container>
  <app-blade-header [bladeIndex]="bladeIndex">
    <div title>
      <i class="icon fas fa-bus"></i>
      @if (title$ | async; as title) {
        {{title}}
      }
    </div>
    <div actions>
      <span class="time-stamp">
        <i class="icon fas fa-history"></i>
      </span>
    </div>
  </app-blade-header>

  @if (blockActivities?.length > 0) {
    <div class="details large-properties highlight-background add-shadow flex" style="flex-direction: column">
      @if (blockActivities?.length > 0) {
        <div class="large-properties" (click)="headerClicked()">
          <div class="property">
            <div class="label"><i class="fas fa-bus"></i></div>
            <div class="value">{{inventoryNumber}}</div>
          </div>
          <div class="property">
            <div class="label"><i class="fas fa-route"></i> <span translate>Route</span></div>
            <div class="value">{{activeRoutePublicName}}</div>
          </div>
          <div class="property">
            <div class="label"><i class="fas fa-code-branch"></i> <span translate>Trip</span></div>
            <div class="value">{{activeTripNumber}}</div>
          </div>
        </div>
      }
      @if (blockActivities?.length > 0) {
        <button mat-raised-button class="crosshairs" (click)="focusOnActiveEvent()" disabled="{{ currentSectionId === '' }}">
          <i class="icon fas fa-crosshairs"></i>
          <span class="ml-3">{{ 'Scroll to current event' | translate }}</span>
        </button>
      }
    </div>
  }

  <div class="timelines" appScrollSpy querySelector=".trip-header"
    (sectionChange)="onSectionChange($event)" (scrollend)="onScrollEnd()">
    @for (activityInfo of blockActivities; track activityInfo.selectorId) {
      <div class="timeline" id="timeline">
        <mat-divider></mat-divider>
        <div class="trip-header large-properties highlight-background" [attr.id]="activityInfo.selectorId" (click)="activityClicked(activityInfo)">
          <div class="property">
            <div class="label"><i class="fas fa-clock"></i> <span translate>Time</span></div>
            <div class="value">{{activityInfo?.time}}</div>
          </div>
          <div class="property">
            <div class="label"><i class="fas fa-route"></i> <span translate>Route</span></div>
            <div class="value">{{activityInfo?.routePublicName}}</div>
          </div>
          <div class="property">
            <div class="label"><i class="fas fa-code-branch"></i> <span translate>Trip</span></div>
            <div class="value">{{activityInfo?.tripNumber}}</div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="timeline relative-position">
          <div class="line"></div>
          @for (item of activityInfo.events; track item.selectorId) {
            <div class="cards">
              <!-- scroll to a card -->
              <app-activity-card [isActive]="item.isActive" [data]="item" [attr.id]="item.selectorId" style="scroll-margin-top: 1rem;"></app-activity-card>
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-container>
